import * as d3 from 'd3';
import { FACTOR_ENUMS } from 'pages/RedesignDashboard/constants';
import { isEmpty } from 'helpers/string.helper';
import { getSimplifiedDate } from 'helpers/dateHelper';
import { isFirstTimeCreditUser } from 'helpers/tuCreditReport.helper';
import { setShouldShowExpandedEngagementModule } from 'helpers/sessionstorage';
import {
  FONT_FAMILY_BASE,
  FONT_FAMILY_BOLD,
  FONT_WEIGHT_BASE,
  FONT_WEIGHT_BOLD,
} from 'customBrandStylePath/brand.constants';
import system from 'style/_system_colors.scss';

const FACTOR_ENUMS_ARRAY = Object.keys(FACTOR_ENUMS);

const boxSize = 500;
const BLUE = 'BLUE';
const RED = 'RED';
const PimpleColor = {
  [BLUE]: system.system_info_i300,
  [RED]: '#d83c33',
};
export const factorColorConfig = {
  A: {
    color: system.system_success_s075,
    borderColor: system.system_success_s100,
    shadowColor: system.system_success_s075,
  },
  B: {
    color: system.system_ltgreen_lg075,
    borderColor: system.system_ltgreen_lg100,
    shadowColor: system.system_ltgreen_lg075,
  },
  C: {
    color: system.system_warn_w075,
    borderColor: system.system_warn_w100,
    shadowColor: system.system_warn_w075,
  },
  D: {
    color: system.system_orange_o075,
    borderColor: system.system_orange_o100,
    shadowColor: system.system_orange_o075,
  },
  F: {
    color: system.system_error_e075,
    borderColor: system.system_error_e100,
    shadowColor: system.system_error_e075,
  },
};

export const factorColorConfigArray = [
  {
    color: system.system_neutral_n025,
    borderColor: system.system_neutral_n050,
  },
  {
    color: system.system_neutral_n025,
    borderColor: system.system_neutral_n050,
  },
  {
    color: system.system_neutral_n025,
    borderColor: system.system_neutral_n050,
  },
  {
    color: system.system_neutral_n025,
    borderColor: system.system_neutral_n050,
  },
  {
    color: system.system_neutral_n025,
    borderColor: system.system_neutral_n050,
  },
];

// Clicked factor once
let flag = false;

const drawGradeDonut = (
  element,
  data,
  CsGrade,
  handleClick,
  isSomeFactorClicked,
  selectedFactor,
  isPotentialView,
  clickable,
  potentialCreditProfileContainerError,
  handleTryAgainPotentialCreditProfile,
  setShowEngagement,
  showEngagement,
  eventEngagementData,
  showEngagementModuleFromFlag,
  handleGoToCreditReports,
  config,
) => {
  const labelsDonuts = config?.dialDonutLabel;
  const DonutsInnerLabel = config?.dialInnerPotentialLabel;

  // Remove the old svg
  d3.select(element).select('svg').remove();
  // Create new svg
  const svg = d3
    .select(element)
    .append('svg')
    .attr('preserveAspectRatio', 'xMidYMid meet')
    .attr('role', 'group')
    .attr('height', '100%')
    .attr('aria-label', 'meet')
    .attr('width', '100%')
    .attr('viewBox', `0 0 ${boxSize} ${boxSize}`)
    .append('g')
    .attr('transform', `translate(${boxSize / 2}, ${boxSize / 2})`);

  if (isPotentialView && !isSomeFactorClicked) {
    if (potentialCreditProfileContainerError) {
      svg
        .append('text')
        .attr('x', 0)
        .attr('y', 15)
        .style('text-anchor', 'middle')
        .text('THERE WAS AN ERROR')
        .style('fill', system.system_neutral_n400)
        .style('font-weight', 'bold')
        .style('font-size', '18px');

      svg
        .append('text')
        .attr('x', 0)
        .attr('y', 70)
        .style('text-anchor', 'middle')
        .style('font-size', '18px')
        .style('font-weight', 'bold')
        .style('color', system.system_info_i300)
        .style('cursor', 'pointer')
        .text('TRY AGAIN')
        .on('click', function () {
          handleTryAgainPotentialCreditProfile();
        });
    } else if (CsGrade.qualification > 0) {
      svg
        .append('text')
        .attr('x', 0)
        .attr('y', -10)
        .style('text-anchor', 'middle')
        .text(CsGrade.qualification)
        .style('fill', system.system_neutral_n400)
        .style('font-weight', 'bold')
        .style('font-size', '64px');

      svg
        .append('text')
        .attr('x', 0)
        .attr('y', 30)
        .attr('textLength', 230)
        .attr('lengthAdjust', 'spacingAndGlyphs')
        .style('text-anchor', 'middle')
        .text(DonutsInnerLabel)
        .style('fill', system.system_neutral_n400)
        .style('font-weight', 'bold')
        .style('font-size', '20px');
    } else {
      svg
        .append('text')
        .attr('x', 0)
        .attr('y', 15)
        .style('text-anchor', 'middle')
        .text('NO ACTIONS AT THIS TIME')
        .style('fill', system.system_neutral_n400)
        .style('font-weight', 'bold')
        .style('font-size', '18px');

      svg
        .append('text')
        .attr('x', 0)
        .attr('y', 70)
        .style('text-anchor', 'middle')
        .style('font-size', '18px')
        .style('font-weight', 'bold')
        .style('color', system.system_info_i300)
        .style('cursor', 'pointer')
        .text('CHECK YOUR GOALS')
        .on('click', function () {
          window.location.assign('/goals');
        });
    }

    const arcGenerator = d3
      .arc()
      .cornerRadius(12)
      .padAngle(0.02)
      .innerRadius(130)
      .outerRadius(250);

    const pieGenerator = d3
      .pie()
      .startAngle(0)
      .value(d => d.value);

    const arcs = svg.selectAll().data(pieGenerator(data)).enter();

    arcs
      .append('path')
      .attr('tabindex', 0)
      .attr('d', arcGenerator)
      .attr('id', d => `${d.data.id}`)
      .attr('class', 'dashboard-credit-ring-factor')
      .attr('role', 'img')
      .attr('aria-label', d => `${d.data.name} grade ${d.data.qualification}`)
      .style('fill', system.system_info_i025)
      .style('stroke', system.system_info_i050)
      .style('stroke-width', 2)
      .style('cursor', (d, i) => {
        if (data[i].numberOfNotifications > 0) {
          return isSomeFactorClicked ? 'default' : 'pointer';
        }
      })
      .attr('opacity', (d, i) => {
        if (potentialCreditProfileContainerError) {
          return 0.2;
        } else {
          return data[i].numberOfNotifications > 0 ? 1 : 0.2;
        }
      })
      .on('click', (d, i) => {
        data[i.index].numberOfNotifications > 0 && handleClick(d.target.id);
      })
      .transition();

    // Append text labels
    arcs
      .append('text')
      .attr('text-anchor', 'middle')
      .attr('id', d => `${d.data.id}`)
      .style('fill', system.system_neutral_n400)
      .style('font-size', '40px')
      .style('font-weight', 'bold')
      .attr('transform', d => {
        const [x, y] = arcGenerator.centroid(d);
        return `translate(${x}, ${y})`;
      })
      .style('cursor', isSomeFactorClicked ? 'default' : 'pointer')
      .style('font-size', 0)
      .style('font-size', '40px')
      .style('font-weight', 'bold');

    arcs
      .append('text')
      .attr('text-anchor', 'middle')
      .attr('id', d => `${d.data.id}`)
      .text((d, i) => labelsDonuts[i % data.length].toUpperCase())
      .style('fill', system.system_info_i300)
      .style('font-size', '16px')
      .style('font-weight', 700)
      .attr('transform', d => {
        const [x, y] = arcGenerator.centroid(d);
        return `translate(${x}, ${y + 20})`;
      })
      .attr('opacity', (d, i) => {
        return data[i].numberOfNotifications > 0 ? 1 : 0.2;
      })
      .on('click', d => {
        clickable && handleClick(d.target.id);
      })
      .style('cursor', (d, i) => {
        if (data[i].numberOfNotifications > 0) {
          return isSomeFactorClicked ? 'default' : 'pointer';
        }
      })
      .style('padding-top', '20px')
      .style('font-size', '16px');

    if (!potentialCreditProfileContainerError) {
      arcs
        .append('circle')
        .attr('text-anchor', 'middle')
        .attr('r', (d, i) =>
          data[i].hasNotifications && data[i].numberOfNotifications > 0
            ? '23px'
            : '0px',
        )
        .attr('transform', d => {
          const [x, y] = arcGenerator.centroid(d);
          return `translate(${x}, ${y - 25})`;
        })
        .style('fill', system.system_info_i300)
        .style('font-size', 0)
        .style('font-size', '16px');
      arcs
        .append('text')
        .attr('text-anchor', 'middle')
        .text((d, i) =>
          data[i].hasNotifications && data[i].numberOfNotifications > 0
            ? data[i].numberOfNotifications
            : '',
        )
        .style('fill', '#fff')
        .attr('transform', d => {
          const [x, y] = arcGenerator.centroid(d);
          return `translate(${x}, ${y - 18})`;
        })
        .style('font-size', 0)
        .style('font-size', '20px')
        .style('cursor', (d, i) => {
          if (data[i].numberOfNotifications > 0) {
            return isSomeFactorClicked ? 'default' : 'pointer';
          }
        })
        .on('click', (_, i) => {
          clickable && handleClick(i.data.id);
        })
        .style('background-color', PimpleColor[RED]);
    }
  } else {
    svg
      .append('text')
      .attr('x', 0)
      .attr('y', -65)
      .style('text-anchor', 'middle')
      .text(() => (isSomeFactorClicked ? '' : 'VantageScore® 3.0'))
      .style('fill', system.system_neutral_n300)
      .style('font-family', FONT_FAMILY_BASE)
      .style('font-weight', FONT_WEIGHT_BASE)
      .style('font-size', '15px');

    let scorePosition;
    if (showEngagementModuleFromFlag && !isEmpty(eventEngagementData)) {
      scorePosition = isSomeFactorClicked ? -25 : 15;
    } else {
      scorePosition = isSomeFactorClicked ? 30 : 25;
    }
    svg
      .append('text')
      .attr('x', 0)
      .attr('y', scorePosition)
      .style('text-anchor', 'middle')
      .call(function (text) {
        const idx = FACTOR_ENUMS_ARRAY.indexOf(selectedFactor);
        text
          .append('tspan')
          .attr('x', 10)
          .attr('dy', 0)
          .style('font-size', '84px')
          .text(
            isSomeFactorClicked
              ? `${data[idx]?.displayLabel}%`
              : isFirstTimeCreditUser(CsGrade?.score)
              ? '--'
              : CsGrade?.score,
          );

        if (isSomeFactorClicked && (idx === 2 || idx === 3)) {
          const labelMixLength =
            selectedFactor === 'ACCOUNT_MIX' ? 'MIX + LENGTH' : 'LENGTH + MIX';
          text
            .append('tspan')
            .attr('x', 3)
            .attr('dy', '1.6em')
            .style('font-size', '28px')
            .text(labelMixLength);
        }
      })
      .on('click', handleGoToCreditReports)
      .style('cursor', 'pointer')
      .style('fill', system.system_neutral_n400)
      .style('font-family', FONT_FAMILY_BOLD)
      .style('font-weight', FONT_WEIGHT_BOLD)
      .style('font-size', '84px');

    if (showEngagementModuleFromFlag && !isEmpty(eventEngagementData)) {
      svg
        .append('svg:image')
        .attr(
          'xlink:href',
          'https://csesamesecure.s3.amazonaws.com/s3adminportalmanager/release_team///alert.png',
        )
        .attr('x', '-25')
        .attr('y', '50')
        .attr('width', '55')
        .attr('height', '55')
        .style('cursor', 'pointer')
        .on('click', () => {
          if (showEngagement) {
            setShowEngagement(showEngagement);
          } else {
            setShowEngagement(!showEngagement);
          }
          setShouldShowExpandedEngagementModule(true);
        });
    } else {
      svg
        .append('text')
        .attr('x', 0)
        .attr('y', 60)
        .style('text-anchor', 'middle')
        .text(() =>
          isSomeFactorClicked
            ? ''
            : isFirstTimeCreditUser(CsGrade?.score)
            ? 'Limited Credit History'
            : `as of ${getSimplifiedDate(CsGrade.date)}`,
        )
        .style('fill', system.system_neutral_n300)
        .style('font-family', FONT_FAMILY_BASE)
        .style('font-weight', FONT_WEIGHT_BASE)
        .style('font-size', '18px');
    }

    const arcGenerator = d3
      .arc()
      .cornerRadius(12)
      .padAngle(0.04)
      .innerRadius(130)
      .outerRadius(245);

    const arcGeneratorSub = d3
      .arc()
      .cornerRadius(8)
      .startAngle(Math.PI * 3.58)
      .endAngle(Math.PI * 3.62)
      .innerRadius(133)
      .outerRadius(245);

    const pieGenerator = d3
      .pie()
      .startAngle(0)
      .value(d => d.value);

    const arcs = svg.selectAll().data(pieGenerator(data)).enter();

    arcs
      .append('path')
      .attr('d', arcGeneratorSub)
      .attr('id', 'credit-depth')
      .attr('class', 'dashboard-credit-ring-factor-connector')
      .attr('role', 'img')
      .attr('aria-label', d => `${d.data.name} grade ${d.data.qualification}`)
      .attr('tabindex', -1)
      .style('fill', d => {
        if (isSomeFactorClicked) {
          const idx = FACTOR_ENUMS_ARRAY.indexOf(selectedFactor);
          if (idx === 3 || idx === 2) {
            return 'black';
          } else {
            return '#A6A7A9';
          }
        } else {
          return system.neutral400;
        }
      })
      .attr('opacity', () => (isSomeFactorClicked ? 0.2 : 1));

    arcs
      .append('path')
      .attr('d', arcGenerator)
      .attr('id', d => d.data.id)
      .attr('class', 'dashboard-credit-ring-factor')
      .attr('role', 'img')
      .attr('aria-label', d => `${d.data.name} grade ${d.data.qualification}`)
      .attr('tabindex', 0)
      // .attr('id', d => `${d.data.name}`)
      .style('fill', d => {
        if (isSomeFactorClicked) {
          const idx = FACTOR_ENUMS_ARRAY.indexOf(selectedFactor);
          if (d.data.focus) {
            return factorColorConfig[d.data?.qualification]?.color;
          } else {
            if (d.data.id === 3 && idx === 3) {
              return system.system_neutral_n050;
            }
            if (d.data.id === 4 && idx === 2) {
              return system.system_neutral_n050;
            }
            return factorColorConfigArray[d.data.id - 1]?.color;
          }
        } else {
          return factorColorConfig[d.data?.qualification]?.color;
        }
      })
      .style('stroke', d => {
        if (isSomeFactorClicked) {
          const idx = FACTOR_ENUMS_ARRAY.indexOf(selectedFactor);
          if (d.data.focus) {
            if (idx === 3 || idx === 2) {
              return system.system_neutral_n500;
            }
            return factorColorConfig[d.data?.qualification]?.borderColor;
          } else {
            if (d.data.id === 3 && idx === 3) {
              return system.system_neutral_n500;
            }
            if (d.data.id === 4 && idx === 2) {
              return system.system_neutral_n500;
            }
            return factorColorConfigArray[d.data.id - 1]?.borderColor;
          }
        } else {
          return factorColorConfig[d.data?.qualification]?.borderColor;
        }
      })
      .style('stroke-width', () => {
        const idx = FACTOR_ENUMS_ARRAY.indexOf(selectedFactor);
        if (isSomeFactorClicked) {
          if (idx === 3 || idx === 2) {
            return 6;
          }
        }
        return 2;
      })
      .style('cursor', isSomeFactorClicked ? 'default' : 'pointer')
      .on('click', d => {
        clickable && handleClick(d.target.id);
      })
      .on('focus', function (event, d) {
        d3.select(this).style(
          'fill',
          factorColorConfig[d.data?.qualification]?.borderColor,
        );
      })
      .on('blur', function (d, i) {
        d3.select(this).style('fill', 'transparent');
        d3.select(this).style(
          'fill',
          (d, i) => factorColorConfig[d.data?.qualification]?.color || 'green',
        );
      })
      .on('keypress', function (event, d) {
        if (event.keyCode === 32 || event.keyCode === 13) {
          clickable && handleClick(d.data.id);
        }
      })
      .transition()
      .on('start', function repeat(d, i) {
        if (isSomeFactorClicked) {
          flag = true;
        }
        if (clickable && !flag) {
          d3.active(this)
            .style(
              'stroke',
              factorColorConfig[d.data.qualification]?.shadowColor,
            )
            .transition()
            .delay(1200)
            .style(
              'stroke',
              factorColorConfig[d.data.qualification]?.borderColor,
            )
            .style('stroke-width', 8)
            .transition()
            .delay(1200)
            .on('start', repeat);
        }
      });

    // Append text labels
    arcs
      .append('text')
      .attr('text-anchor', 'middle')
      .attr('id', d => `${d.data.id}`)
      .text(d => `${d.data.qualification}`)
      .style('font-size', '40px')
      .style('font-family', FONT_FAMILY_BOLD)
      .style('font-weight', FONT_WEIGHT_BOLD)
      .attr('transform', d => {
        const [x, y] = arcGenerator.centroid(d);
        return `translate(${x}, ${y})`;
      })
      .style('cursor', isSomeFactorClicked ? 'default' : 'pointer')
      .on('click', d => {
        // !isSomeFactorClicked && handleClick(d.target.id);
        handleClick(d.target.id);
      })
      .style('font-size', 0)
      .style('font-size', '40px')
      .style('color', d => {
        if (isSomeFactorClicked) {
          if (!d?.data?.focus) {
            return system.system_neutral_n250;
          }
        }
      });

    arcs
      .append('text')
      .attr('text-anchor', 'middle')
      .attr('id', d => `${d.data.id}`)
      .text((d, i) =>
        isSomeFactorClicked ? '' : labelsDonuts[i % data.length].toUpperCase(),
      )
      .style('fill', system.system_neutral_n400)
      .style('font-size', '16px')
      .attr('transform', d => {
        const [x, y] = arcGenerator.centroid(d);
        return `translate(${x}, ${y + 20})`;
      })
      .style('cursor', isSomeFactorClicked ? 'default' : 'pointer')
      .on('click', d => {
        // !isSomeFactorClicked && handleClick(d.target.id);
        clickable && handleClick(d.target.id);
      })
      .style('padding-top', '20px')
      .style('font-family', FONT_FAMILY_BOLD)
      .style('font-weight', FONT_WEIGHT_BOLD)
      .style('font-size', '16px');

    arcs
      .append('circle')
      .attr('text-anchor', 'middle')
      .attr('r', (d, i) =>
        data[i].hasNotifications &&
        data[i].numberOfNotifications > 1 &&
        data[i].pimpleColor !== BLUE
          ? '11px'
          : '7px',
      )
      .style('fill', (d, i) =>
        data[i].hasNotifications
          ? PimpleColor[data[i].pimpleColor]
          : 'transparent',
      )
      .attr('transform', d => {
        const [x, y] = arcGenerator.centroid(d);
        return `translate(${x + 26}, ${y - 20})`;
      })
      .style('font-size', 0)
      .style('padding-top', '20px')
      .style('font-family', FONT_FAMILY_BOLD)
      .style('font-weight', FONT_WEIGHT_BOLD)
      .style('font-size', '16px');

    arcs
      .append('text')
      .attr('text-anchor', 'middle')
      .text((d, i) =>
        data[i].hasNotifications &&
        data[i].numberOfNotifications > 1 &&
        data[i].pimpleColor !== BLUE
          ? data[i].numberOfNotifications
          : '',
      )
      .style('fill', '#fff')
      .attr('transform', d => {
        const [x, y] = arcGenerator.centroid(d);
        return `translate(${x + 26}, ${y - 16})`;
      })
      .style('font-size', 0)
      .style('padding-top', '20px')
      .style('font-size', '14px')
      .style('background-color', PimpleColor[RED]);

    d3.select(element).on('click', function (e) {
      // const id = e.target.id;
      // This is to achieve the animation, actually not needed for highlight
      // svg.selectAll('path').each(function (d, i) {
      //   d3.select(this)
      //     .transition()
      //     .duration(500)
      //     .ease(d3.easeLinear)
      //     .style('opacity', d.data.id === Number(id) ? 1 : 0.2);
      // });
    });
  }
};

export default drawGradeDonut;
